// extracted by mini-css-extract-plugin
export default {"row":"sbVVbicPQqkKdbSezpGA"};